import Box from '@mui/material/Box';
import { List } from '@mui/material';
import SideMenuLinkItem from './SideMenuLinkItem';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import UserButton from './UserButton';
import SupportButton from '../common/SupportButton';

const SideMenu = () => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        maxHeight: '100%',
        width: 60,
        backgroundColor: 'white',
        py: 2,
      }}>

      <List sx={{
        '&': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          flexDirection: 'column',
          width: '100%',
          gap: 1,
          p: 0,
        },
      }}>
        <SideMenuLinkItem
          to={`/services`}
          icon={<AddPhotoAlternateOutlinedIcon style={{ fontSize: 24, padding: 0 }} />}
          style={{ width: 'auto', paddingBottom: 4 }}
        />
        <SideMenuLinkItem
          to={`/cabinet`}
          icon={<DashboardCustomizeOutlinedIcon style={{ fontSize: 24, padding: 0 }} />}
          style={{ width: 'auto', paddingBottom: 4 }}
        />
      </List>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}>
        <SupportButton />
        <UserButton />
      </Box>
    </Box>
  );
};
export default SideMenu;